/* =========================================================
   sports&deco — Parser FIT (binaire Garmin/wearables)
   Utilise fit-file-parser chargé via CDN dans le HTML.
   ========================================================= */

function parseFIT(arrayBuffer) {
  if (typeof FitParser === 'undefined') {
    throw new Error('FIT: librairie non chargée');
  }

  return new Promise((resolve, reject) => {
    const parser = new FitParser({
      force: true,
      speedUnit: 'km/h',
      lengthUnit: 'km',
      temperatureUnit: 'celsius',
      elapsedRecordField: true,
      mode: 'list',
    });

    parser.parse(arrayBuffer, (err, data) => {
      if (err) return reject(new Error('FIT: ' + err));

      const records = (data.records || []).filter(
        (r) => Number.isFinite(r.position_lat) && Number.isFinite(r.position_long)
      );
      if (!records.length) return reject(new Error('FIT: aucun point GPS trouvé'));

      const samples = records.map((r) => ({
        lat: r.position_lat,
        lon: r.position_long,
        ele: Number.isFinite(r.altitude) ? r.altitude : (Number.isFinite(r.enhanced_altitude) ? r.enhanced_altitude : null),
        time: r.timestamp ? new Date(r.timestamp) : null,
      }));

      const session = (data.sessions && data.sessions[0]) || {};
      const sportRaw = session.sport || data.activity?.sport || null;

      resolve({
        sourceFormat: 'fit',
        name: null,
        sportRaw,
        samples,
      });
    });
  });
}
